import CampaignFilledIcon from '@mui/icons-material/Campaign'
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined'
import HomeFilledIcon from '@mui/icons-material/Home'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'
import PersonFilledIcon from '@mui/icons-material/Person'
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined'
import SmsFilledIcon from '@mui/icons-material/Sms'
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined'
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material'
import { LDFlagSet, useFlags } from 'launchdarkly-react-client-sdk'
import { useRouter } from 'next/router'
import { FC, JSX, useCallback, useEffect, useMemo, useState } from 'react'
import { pagesPath } from '~/lib/$path'

export const BOTTOM_NAVIGATION_HEIGHT = 56

const allActions = [
  {
    label: 'ホーム',
    value: 'home',
    path: pagesPath.home.$url().pathname,
    icon: <HomeOutlinedIcon />,
    selectedIcon: <HomeFilledIcon />,
  },
  {
    label: 'キャンペーン',
    value: 'campaign',
    path: pagesPath.campaigns.$url().pathname,
    icon: <CampaignOutlinedIcon />,
    selectedIcon: <CampaignFilledIcon />,
  },
  {
    label: 'やりとり',
    value: 'offer',
    path: '/offers',
    icon: <SmsOutlinedIcon />,
    selectedIcon: <SmsFilledIcon />,
    showCondition: (flags: LDFlagSet) => flags.releaseCampaigns,
  },
  {
    label: 'マイページ',
    value: 'mypage',
    path: pagesPath.adv_account.personal_info.$url().pathname,
    icon: <PersonOutlinedIcon />,
    selectedIcon: <PersonFilledIcon />,
  },
] as Array<{
  label: string
  value: string
  path: string
  icon: JSX.Element
  selectedIcon: JSX.Element
  showCondition?: (flags: LDFlagSet) => boolean
}>

export const AppBottomNavigation: FC = () => {
  const { asPath, push } = useRouter()
  const [value, setValue] = useState('')

  const handleAction = useCallback(
    (path: string) => {
      return () => {
        push(path)
      }
    },
    [push],
  )

  const flags = useFlags()
  const actions = useMemo(() => {
    return allActions.filter((action) => {
      if (action.showCondition) {
        return action.showCondition(flags)
      }
      return true
    })
  }, [flags])

  useEffect(() => {
    const action = actions.find((action) => asPath.startsWith(action.path))
    if (action) {
      setValue(action.value)
    }
  }, [actions, asPath])

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        width: '100%',
        // keep safe area
        paddingBottom: 'env(safe-area-inset-bottom, 0)',
        backgroundColor: 'surface.primary',
        zIndex: (theme) => theme.zIndex.appBar,
      }}
      elevation={0}
    >
      <BottomNavigation
        showLabels
        value={value}
        onChange={(_, newValue) => {
          setValue(newValue)
        }}
        sx={{
          backgroundColor: 'surface.primary',
        }}
      >
        {actions.map((action) => (
          <BottomNavigationAction
            key={action.value}
            label={action.label}
            value={action.value}
            icon={value === action.value || asPath === action.path ? action.selectedIcon : action.icon}
            onClick={handleAction(action.path)}
            sx={{
              '& > .MuiBottomNavigationAction-label': {
                fontSize: '11px',
                fontWeight: 500,
                lineHeight: 1.35,
              },
              '& > .MuiBottomNavigationAction-label.Mui-selected': {
                fontSize: '11px',
              },
            }}
          />
        ))}
      </BottomNavigation>
    </Paper>
  )
}
